import { PageInfo } from 'kinetic-angular';
import { FilterData, FilterPanelSection, Image, LocationAddress, SearchLabels } from '../../../services/shared/shared-interface';
import { SortOrder } from '../../../services/shared/shared-enums';
import { ResponseDealerAddress } from '../sub-modules/equipment-order-details/definitions/equipment-order-details.interface';

export interface OrderManagement {
    state: OrderManagementState;
}
export interface OrderManagementState {
    sectionHeader: OrderManagementTop;
    sectionEquipmentOrder: OrderManagementMiddle;
    sectionOrderList: OrderManagementBottom;
}

export interface OrderManagementStateLabel {
    sectionTop: { heading: string };
    sectionMiddle: OrderManagementSectionMiddle;
    sectionBottom: OrderManagementBottom;
}
export interface OrderManagementTop {
    sectionTop : { heading: string | undefined };
}
export interface OrderManagementMiddle {
    heading: string | null;
    subHeading: string;
    search: SearchLabels;
    filteringPanelSection: FilterPanelSection;
    download: string;
    invoiceStatusUpdated: boolean;
}
export interface OrderManagementSectionMiddle {
    heading: string;
    subHeading: string;
    search: SearchLabels;
    filter: FilterData;
    filterForm: FilterFormData;
    download: string;
    invalidSearchText: string;
}
export interface OrderManagementBottom {
    orderStatus: OrderStatusData[];
    gridData: EquipmentOrderListHeaderData;
}
export interface EquipmentOrderListHeaderData {
    crmOppNumber: string;
    truckNumber: string;
    orderDate: string;
    status: string;
    billingLocation: string;
    shippingLocation: string;
    billingLocationAddress?: ResponseDealerAddress;
    shippingLocationAddress?: ResponseDealerAddress;
    model: string;
}
export interface OrderStatusData {
    label: string;
    altText: string;
}
export interface FilterFormData {
    formLabel: string;
    searchLocation: {
        accordionIconExpanded: Image;
        accordionIconCollapsed: Image;
        label: string;
        searchPlaceholder: string;
        searchIcon: Image;
        noResultsFoundLabel: string;
    };
    shippingLocation: {
        accordionIconExpanded: Image;
        accordionIconCollapsed: Image;
        label: string;
        searchPlaceholder: string;
        searchIcon: Image;
        noResultsFoundLabel: string; 
        errorMessage: string;
    };
    dateRange: {
        accordionIconExpanded: Image;
        accordionIconCollapsed: Image;
        label: string;
        values: string[];
        customDateFromLabel: string;
        customDateToLabel: string;
    };
    division: CheckBoxFilter;
    group: CheckBoxFilter;
    clearAllButtonLabel: string;
    applyButtonLabel: string;
}

export interface CheckBoxFilter {
    label: string;
    accordionIconExpanded: Image;
    accordionIconCollapsed: Image;
    search: SearchLabels;
    noResultsFoundLabel: string;
    noAssociatedGroupsFoundLabel?: string;
    showMoreText?: string;
    showLessText?: string;
}
export interface OrderManagementSelectedFilter {
    key: string;
    value: string;
    id?: string;
    
  }
export interface OrderListPayload {
    skip: number;
    limit: number;
    startDate?: number;
    endDate?: number;
    locations?: string[];
    search?:string;
    sort?: OrderListSort;
    status: string;
    shippingLocations?: LocationAddress[]; 
}
export interface OrderListSort {
    field: string;
    order: SortOrder;
}
export interface EquipmentOrderList {
    key: string;
    value: string;
}
export interface OrderListResponse {
    equipmentOrders: EquipmentOrderListHeaderData[];
    pageInfo: PageInfo;
    deliveredCount: number;
    inProductionCount: number;
    orderinProcessCount:number;
    shippedCount: number;
}
export interface OrderListHeader {
    crmOppNumber?: string;
    truckNumber: string;
    orderDate: string;
    status: string;
    location: string;
    vin: string;
    equipmentType: string;
    ETA: string;
}
export enum OrderHeaderName {
    crmOppNumber = 'Order #',
    orderNumber = 'Order #',
    orderDate = 'Order Date',
    status = 'Status',
    location = 'Location',
    equipmentVin = 'Equipment VIN',
    equipmentType = 'Equipment Classification',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ETA = 'ETA',
}
export enum EquipmentOrderTablelHeaderName {
    crmOppNumber = 'Order#',
    truckNumber = 'Truck#',
    orderDate = 'Order Date',
    location = 'Billing Address',
    shippingLocation = 'Shipping Address',
    model = 'Model',
    status = 'Status'
}

export enum InvoiceStatusLabel {
  all = 'All',
  orderinProcess = 'In Process',
  inProduction = 'In Production',
  shipped = 'Shipped',
  delivered = 'Delivered'
}
export enum InvoiceStatusHeader {
    all = 'all',
    orderinProcess = 'orderinProcess',
    inProduction = 'inProduction',
    shipped = 'shipped',
    delivered = 'delivered'
}

export interface OrderDetailsPayload {
    locations: string[];
    truckNumber: string;
}
export interface ShippingLocationPayload {
    locations: string[];
}
export interface ShippingLocationListResponse {
    records: LocationAddress[];
}
